import { makeObservable } from 'mobx'
import type { FirebaseRepository } from '../models/FirebaseRepository'
import { Cubit } from './core'
import { fetchSection } from '../firestore/Section'
import type { ImpersonationInfo } from '../types'

/**
 * The only job of this cubit is to expose `fetchSection`
 *
 * it's purely a middleman as the pattern of our repo is to not expose queries directly
 * to the client.
 */
export class CreateOrEditSectionDialogCubit extends Cubit {
  repository: FirebaseRepository
  role: string
  impersonationInfo?: ImpersonationInfo

  constructor(
    repository: FirebaseRepository,
    {
      role,
      impersonationInfo,
    }: {
      role: string
      impersonationInfo?: ImpersonationInfo
    }
  ) {
    super()
    makeObservable(this)
    this.repository = repository
    this.role = role
    this.impersonationInfo = impersonationInfo
  }

  initialize(): void {}

  fetchSection = (sectionId: string) => {
    return fetchSection(this.repository, { sectionId })
  }
}
